import axios from "axios";
import { useContext, useEffect, useMemo } from "react";
import { ContextT } from "./DataContext";
import classes from "./Terminal.module.css";

const useCommands = (
  pushToHistory,
  setHistory,
  setOpenTerminal,
  commandsHistory,
  openModalWithData
) => {
  const apiUrlFiles = process.env.REACT_APP_FILES_API_URL || "";
  const apiUrlFile = process.env.REACT_APP_FILE_API_URL || "";
  const apiUrlNewFile = process.env.REACT_APP_NEW_FILE_API_URL || "";
  const apiUrlDirectory = process.env.REACT_APP_CHECKDIR_URL || "";
  const apiUrlDeleteFile = process.env.REACT_APP_DELETE || "";
  const apiUrlRenameFile = process.env.REACT_APP_RENAME || "";
  const { setDirectory, command, triggerUpdate } = useContext(ContextT);

  const notAllowedString = ["..", ".", "/", "//", "\\", "\\\\", "'", '"'];

  const getTokenFromStorage = () => {
    return sessionStorage.getItem("token");
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "F2") {
        setHistory([]);
        window.location.reload();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [setOpenTerminal]);

  const commandlist = async () => {
    pushToHistory(
      <>
        <span style={{ color: "orange" }}>
          <strong>Command list</strong>
        </span>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>cd [directory]</p>
          <p className={classes.terminalCommandText}>navigate to directory</p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>cd.</p>
          <p className={classes.terminalCommandText}>
            navigate to root directory level
          </p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>cd..</p>
          <p className={classes.terminalCommandText}>
            navigate up one directory level
          </p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>clear</p>
          <p className={classes.terminalCommandText}>clear terminal history</p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>close</p>
          <p className={classes.terminalCommandText}>close terminal</p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>delete [filename]</p>
          <p className={classes.terminalCommandText}>delete file</p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>dir</p>
          <p className={classes.terminalCommandText}>
            show real file system of this project
          </p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>edit [filename]</p>
          <p className={classes.terminalCommandText}>open and edit file</p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>file [filename]</p>
          <p className={classes.terminalCommandText}>
            open file and view source code
          </p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>github</p>
          <p className={classes.terminalCommandText}>
            show source of this project
          </p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>info</p>
          <p className={classes.terminalCommandText}>
            some info about this terminal
          </p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>ls</p>
          <p className={classes.terminalCommandText}>
            show real file system of this project
          </p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>new [filename]</p>
          <p className={classes.terminalCommandText}>create new file</p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>
            rename [filename] [new filename]
          </p>
          <p className={classes.terminalCommandText}>rename file</p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>site</p>
          <p className={classes.terminalCommandText}>show my website</p>
        </div>
        <div className={classes.terminalRow}>
          <p className={classes.terminalCommand}>skills</p>
          <p className={classes.terminalCommandText}>show my dev skills</p>
        </div>
      </>
    );
  };

  const github = async () => {
    pushToHistory(
      <>
        <br />
        <div className={classes.terminalTextRow}>
          <span style={{ color: "orange" }}>
            <strong>Backend filesystem node server</strong>
          </span>
          <br />
          <a
            href="https://github.com/davidebalice/node-file-system-api"
            target="_blank"
            title="github db"
            rel="noreferrer"
            className={classes.terminalLink}
          >
            https://github.com/davidebalice/node-file-system-api
          </a>
          <br />
          <br />
          <span style={{ color: "orange" }}>
            <strong>Frontend React</strong>
          </span>
          <br />
          <a
            href="https://github.com/davidebalice/react-terminal-emulator"
            target="_blank"
            title="github db"
            rel="noreferrer"
            className={classes.terminalLink}
          >
            https://github.com/davidebalice/react-terminal-emulator
          </a>
          <br />

          <br />
          <br />
        </div>
      </>
    );
  };

  const clear = async () => {
    setHistory([]);
  };

  const site = async () => {
    pushToHistory(
      <>
        <br />
        <div className={classes.terminalTextRow}>
          <span style={{ color: "orange" }}>
            <strong>My website</strong>
          </span>
          <br />
          <a
            href="https://www.davidebalice.dev"
            target="_blank"
            title="davidebalice.dev"
            rel="noreferrer"
            className={classes.terminalLink}
          >
            https://www.davidebalice.dev
          </a>
        </div>
      </>
    );
  };

  const info = async () => {
    pushToHistory(
      <>
        <br />
        <span style={{ color: "orange" }}>
          <strong>Terminal info</strong>
        </span>
        <div className={classes.terminalTextRow}>
          This terminal is just an experiment, developed in React and TypeScript
          for study purpose.
          <br />
          Possible uses are interaction with files system, file creation,
          setting permissions, viewing information, generating passwords and
          more.
        </div>
      </>
    );
  };

  const skills = async () => {
    pushToHistory(
      <>
        <br />
        <span style={{ color: "orange" }}>
          <strong>Skills</strong>
        </span>
        <div className={classes.terminalTextRow}>
          Backend:
          <br />
          Php, Laravel, Node, Express, Java, Spring Boot
          <br />
          <br />
          Frontend:
          <br />
          React, Angular, Javascript, Typescript, jQuery
        </div>
      </>
    );
  };

  const close = async () => {
    setHistory([]);
    setOpenTerminal(false);

    pushToHistory(
      <>
        <div className={classes.terminalTextRow}>
          <span style={{ color: "#ff0000" }}>Terminal closed</span>
          <br />
          <span style={{ color: "#ccc" }}>
            Press <b>F2</b> to restart terminal
          </span>
        </div>
      </>
    );
  };

  const ls = async () => {
    const token = getTokenFromStorage();
    let directory = sessionStorage.getItem("directory");
    await axios
      .get(apiUrlFiles, {
        params: { dir: directory },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log("Response:", response.data);
        const fileList = response.data.items;
        const fileListElements = fileList.map((item, index) => (
          <div key={index} className={classes.filesystemRow}>
            <p
              className={
                item.type === "directory"
                  ? classes.filesystemRowDirectory
                  : classes.filesystemRowFile
              }
            >
              {item.type === "directory" ? (
                <strong>/{item.name}</strong>
              ) : (
                <strong>{item.name}</strong>
              )}
            </p>
            {item.type === "directory" ? (
              <p className={classes.filesystemRowDirectory}>{`<dir>`}</p>
            ) : (
              <p className={classes.filesystemRowFile}>{item.size}kb</p>
            )}
          </div>
        ));

        pushToHistory(
          <>
            <div>
              <span style={{ color: "white" }}>
                <strong>root/{directory}</strong>
              </span>
              {fileListElements}
            </div>
          </>
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const cd = async () => {
    const token = getTokenFromStorage();

    triggerUpdate();
    const verifyCommand = sessionStorage.getItem("command");
    if (verifyCommand === "..") {
      back();
    } else if (verifyCommand === ".") {
      root();
    } else {
      if (verifyCommand !== null && !notAllowedString.includes(verifyCommand)) {
        let currentCommand = "";
        let directory = sessionStorage.getItem("directory");
        if (directory === "" || directory === null) {
          currentCommand = sessionStorage.getItem("command");
        } else {
          currentCommand = directory + `/` + sessionStorage.getItem("command");
        }


        await axios
          .get(apiUrlDirectory, {
            params: { dir: currentCommand },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            console.log("Response:", response.data);
            if (response.data.exists === true) {
              setDirectory(currentCommand);
              sessionStorage.setItem("directory", currentCommand);
            } else {
              pushToHistory(
                <>
                  <div>
                    <span style={{ color: "red" }}>
                      <strong>Directory not found</strong>
                    </span>
                  </div>
                </>
              );
            }
          })
          .catch((error) => {
            pushToHistory(
              <>
                <div>
                  <span style={{ color: "red" }}>
                    <strong>Directory not found</strong>
                  </span>
                </div>
              </>
            );
          });
      }
    }
  };

  const file = async () => {
    const token = getTokenFromStorage();
    triggerUpdate();
    const verifyFile = sessionStorage.getItem("file");

    if (verifyFile !== null && !notAllowedString.includes(verifyFile)) {
      let directory = sessionStorage.getItem("directory");

      await axios
        .get(apiUrlFile, {
          params: { dir: directory, filename: verifyFile },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          console.log("Response:", response.data);
          openModalWithData(response.data.content, response.data.title, false);
        })
        .catch((error) => {
          pushToHistory(
            <>
              <div>
                <span style={{ color: "red" }}>
                  <strong>file not found</strong>
                </span>
              </div>
            </>
          );
        });
    }
  };

  const edit = async () => {
    const token = getTokenFromStorage();
    triggerUpdate();
    const verifyFile = sessionStorage.getItem("edit");

    if (verifyFile !== null && !notAllowedString.includes(verifyFile)) {
      let directory = sessionStorage.getItem("directory");

      await axios
        .get(apiUrlFile, {
          params: { dir: directory, filename: verifyFile },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          console.log("Response:", response.data);
          console.log("error:", response.data.error);

          openModalWithData(response.data.content, response.data.title, true);
        })
        .catch((error) => {
          pushToHistory(
            <>
              <div>
                <span style={{ color: "red" }}>
                  <strong>file not found</strong>
                </span>
              </div>
            </>
          );
        });
    }
  };

  const newfile = async () => {
    const token = getTokenFromStorage();
    triggerUpdate();
    const verifyFile = sessionStorage.getItem("new");

    if (verifyFile !== null && !notAllowedString.includes(verifyFile)) {
      let directory = sessionStorage.getItem("directory");

      await axios
        .post(
          apiUrlNewFile,
          {
            dir: directory,
            filename: verifyFile,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          console.log("Response:", response.data);
          if (response.data.status === "demo") {
            pushToHistory(
              <>
                <div>
                  <span style={{ color: "red" }}>
                    <strong>demo mode: write file is not allowed</strong>
                  </span>
                </div>
              </>
            );
          }
          console.log("error:", response.data.error);
        })
        .catch((error) => {
          pushToHistory(
            <>
              <div>
                <span style={{ color: "red" }}>
                  <strong>file not found</strong>
                </span>
              </div>
            </>
          );
        });
    }
  };

  const deleteFile = async () => {
    const token = getTokenFromStorage();
    triggerUpdate();
    const verifyFile = sessionStorage.getItem("delete");

    if (verifyFile !== null && !notAllowedString.includes(verifyFile)) {
      let directory = sessionStorage.getItem("directory");

      await axios
        .post(
          apiUrlDeleteFile,
          {
            dir: directory,
            filename: verifyFile,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          console.log("Response:", response.data);
          if (response.data.status === "demo") {
            pushToHistory(
              <>
                <div>
                  <span style={{ color: "red" }}>
                    <strong>demo mode: delete file is not allowed</strong>
                  </span>
                </div>
              </>
            );
          }
          console.log("error:", response.data.error);
        })
        .catch((error) => {
          pushToHistory(
            <>
              <div>
                <span style={{ color: "red" }}>
                  <strong>file not found</strong>
                </span>
              </div>
            </>
          );
        });
    }
  };

  const renameFile = async () => {
    const token = getTokenFromStorage();
    triggerUpdate();
    const oldFileName = sessionStorage.getItem("rename");
    const newFileName = sessionStorage.getItem("newname");

    if (oldFileName !== null && !notAllowedString.includes(oldFileName)) {
      let directory = sessionStorage.getItem("directory");

      await axios
        .post(
          apiUrlRenameFile,
          {
            dir: directory,
            oldFileName: oldFileName,
            newFileName: newFileName,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          console.log("Response:", response.data);
          if (response.data.status === "demo") {
            pushToHistory(
              <>
                <div>
                  <span style={{ color: "red" }}>
                    <strong>demo mode: rename file is not allowed</strong>
                  </span>
                </div>
              </>
            );
          }
          console.log("error:", response.data.error);
        })
        .catch((error) => {
          pushToHistory(
            <>
              <div>
                <span style={{ color: "red" }}>
                  <strong>file not found</strong>
                </span>
              </div>
            </>
          );
        });
    }
  };

  const back = async () => {
    let directory = sessionStorage.getItem("directory");

    if (directory !== null && directory !== "") {
      if (directory.includes("\\")) {
        directory = directory.substring(0, directory.lastIndexOf("\\"));
        sessionStorage.setItem("directory", directory);
        setDirectory(directory);
      } else {
        sessionStorage.setItem("directory", "");
        setDirectory("");
      }
    }
  };

  const root = async () => {
    sessionStorage.setItem("directory", "");
    setDirectory("");
  };

  const commands = useMemo(
    () => ({
      clear: clear,
      cd: cd,
      "cd.": root,
      "cd..": back,
      help: commandlist,
      h: commandlist,
      info: info,
      edit: edit,
      file: file,
      github: github,
      close: close,
      site: site,
      skills: skills,
      ls: ls,
      dir: ls,
      rename: renameFile,
      new: newfile,
      delete: deleteFile,
    }),
    [pushToHistory, commandsHistory]
  );

  return commands;
};

export default useCommands;
